import React from 'react';
import { Typography } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { LEARNING_TITLE } from '../constants/landingText';

interface LearningTitleProps {
  fontSize?: { xs: string; md: string };
  maxWidth?: string;
}

const LearningTitle: React.FC<LearningTitleProps> = ({
  fontSize = { xs: '2rem', md: '3.25rem' },
  maxWidth = '50rem',
}) => {
  return (
    <Typography
      variant="headingLarge"
      component="h2"
      sx={{
        fontSize,
        fontWeight: 700,
        lineHeight: { xs: '1.2', md: '1.1' },
        color: colors.neutral.white,
        mb: { xs: 1, md: 1 },
        textAlign: 'center',
        maxWidth,
        margin: '0 auto',
        fontFamily: 'Outfit, sans-serif',
      }}
    >
      {LEARNING_TITLE}
    </Typography>
  );
};

export default LearningTitle;
